/**
 * Constantes de configuración del widget TIA GPC
 */

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8002';
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY;
export const IS_DEV = import.meta.env.DEV;
export const IS_PROD = import.meta.env.PROD;

/**
 * Posiciones disponibles para el widget
 * @readonly
 * @enum {string}
 */
export const WIDGET_POSITIONS = {
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_LEFT: 'bottom-left',
  TOP_RIGHT: 'top-right',
  TOP_LEFT: 'top-left'
};

/**
 * Temas disponibles
 * @readonly
 * @enum {string}
 */
export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
  AUTO: 'auto'
};

/**
 * Idiomas soportados
 * @readonly
 * @enum {string}
 */
export const LANGUAGES = {
  SPANISH: 'es',
  ENGLISH: 'en',
  FRANCES: 'fr'
};

/**
 * Breakpoints responsive (en px)
 * @readonly
 */
export const BREAKPOINTS = {
  MOBILE: 640,
  TABLET: 1024
};

/**
 * Presets de tamaño del widget
 * @readonly
 */
export const WIDGET_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

export const SIZE_DIMENSIONS = {
  [WIDGET_SIZES.SMALL]: { width: '320px', height: '500px' },
  [WIDGET_SIZES.MEDIUM]: { width: '400px', height: '600px' },
  [WIDGET_SIZES.LARGE]: { width: '480px', height: '720px' }
};

/**
 * Configuración del widget por defecto
 * @readonly
 */
export const DEFAULT_WIDGET_CONFIG = {
  theme: THEMES.AUTO,
  position: WIDGET_POSITIONS.BOTTOM_RIGHT,
  language: LANGUAGES.ENGLISH,
  width: '400px',
  height: '600px',
  autoOpen: false,
  showBranding: true,
  mobileFullscreen: true
};

/**
 * Tiempos de timeout (en ms)
 * @readonly
 */
export const TIMEOUTS = {
  API_REQUEST: 30000,
  TURNSTILE: 10000
};

/**
 * Límites de input
 * @readonly
 */
export const INPUT_LIMITS = {
  MIN_LENGTH: 1,
  MAX_LENGTH: 2000
};
